import React from 'react';
import {Paper, Typography} from '@mui/material';
import InstallCriteria from './Main/InstallCriteria';

export default function WarCheckPage() {
    return <Paper sx={{p: {xs: 2, md: 3}}}>
        <Typography variant="h2" sx={{mb: 2}}>WAR 버전 확인</Typography>
        <InstallCriteria/>
    </Paper>;
}
